import React,{useEffect,useState} from 'react'
import {useForm} from 'react-hook-form'
import {toast} from 'react-toastify'
import clinicService from '../../../../../services/clinic.service'
import { Link } from 'react-router-dom'
function LinksCard({linkitem,getLinks}) {
    const [edit,setEdit] = useState(false)
    const { register, handleSubmit, formState:{errors} } = useForm(
        {
            defaultValues:{
                id:linkitem.id,
                linkType:linkitem.linkType,
                clinicId:linkitem.clinicId,
                link:linkitem.link,
                notes:linkitem.notes,
                extraData:linkitem.extraData
            }
        })
   const onSubmit = (data)=>{
    clinicService.addUpdateReputationLink(linkitem.clinicId,data)
    .then(res=>{
        console.log(res.data)
        toast.success("Updated Link",{
            position:toast.POSITION.BOTTOM_RIGHT
        })

    })
    .catch(err=>{
        console.log(err)
        toast.error("Error while updating Link",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
    })
   }

   const handleDelete = (clinicId,id)=>{
    
    clinicService.deleteReputationLink(clinicId,id)
    .then(res=>{
        getLinks()
        toast.success("Deleted the link",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
    })
    .catch(err=>{
        toast.error("Not able to delete the link",{
            position:toast.POSITION.BOTTOM_RIGHT
        })
    })
   }
  return (
    <div className="col-sm-4">
    <div className="card">
        <div className="card-body">
            <div className="d-flex justify-content-between">
                <h5 className="card-title">{linkitem.linkType}</h5>
                <div className='mt-3'>
                    <button className="btn" onClick={()=>setEdit(!edit)}>{edit? "Cancel" :<i className="bi bi-pencil-square"></i>}</button>
                </div>
            </div>
            {!edit ? <>
          
            <Link to={linkitem.link} className='card-subtitle text-body-secondary'  target="_blank" rel="noopener noreferrer">{linkitem.link}</Link>
            <h6 className="card-subtitle text-body-secondary mt-2">Notes : {linkitem.notes}</h6>
            <h6 className="card-subtitle text-body-secondary mt-2">Extra Data : {linkitem.notes}</h6>
            <h6 className="card-subtitle text-body-secondary mt-2">Status : {linkitem.isActive ===1? "Active":"Inactive"}</h6>
            </>:<>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-2">
                    <label className="form-label">Url</label>
                    <input type="text" className="form-control" {...register("link")}/>
                    <input type="hidden" {...register("id")} />
                    <input type="hidden" {...register("clinicId")} />
                    <input type="hidden" {...register('linkType')} />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="" className='form-label'>Notes:</label>
                        <input type="text" className="form-control" {...register("notes")}/>
                  
                    </div>
                    <div className="mb-2">
                        <label htmlFor="" className='form-label'>Extra Data:</label>
                        <input type="text" className="form-control" {...register("extraData")}/>
                  
                    </div>
                    <div className="mb-2">
                       <select className='form-select' {...register("isActive")}>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                       </select>
                    </div>
                    <div className="d-flex justify-content-between">
                                    <button type="submit" className="btn btn-primary btn-sm">Update</button>
                                    <button className="btn btn-danger btn-sm" onClick={()=>handleDelete(linkitem.clinicId,linkitem.id)}>Delete</button>
                                 </div>
                </form>
            </>}
        </div>
    </div>
    </div>
  )
}

export default LinksCard